import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportCasinoResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportCasinoInner() {
    return <PlayerLevelReportBase tab="casino" columnsSettingsViewType="PlayerLevelReportCasino" />;
}

const PlayerLevelReportCasinoWithAccess = withAccessCheck(PlayerLevelReportCasinoInner, playerLevelReportCasinoResource);

export const PlayerLevelReportCasino = withTraceErrorBoundary(PlayerLevelReportCasinoWithAccess, ErrorModal);
